import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import EventBanner from "@/components/site/EventBanner";
import PartnersMarquee from "@/components/site/PartnersMarquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Players from "@/components/site/Players";
import News from "@/components/site/News";
import Affiliates from "@/components/site/Affiliates";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -72 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-[#0A0A0C] text-white min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <EventBanner />
        <PartnersMarquee />
        <About />
        <Services />
        <Players />
        <News />
        <Affiliates />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
